/**
 * API 接口管理
 * 统一管理所有 API 请求
 */
import request from './request';

export const commonApi = {
  // GET 请求
  get(url, params) {
    return request({
      url,
      method: 'get',
      params,
    });
  },
};

// 默认导出所有 API
export default {
  commonApi,
};

